import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class CDFTypes {
  static list: IActionType = new ActionType('CDF/LIST_DOCUMENTS');
  static details: IActionType = new ActionType('CDF/LOAD_DETAILS');
  static urlDownload: IActionType = new ActionType('CDF/URL_DOWNLOAD');
  static export: IActionType = new ActionType('CDF/EXPORT');
}

export default CDFTypes;
